import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('trash.groups'),
      path: 'trash/groups',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'trash/groups/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.historical'),
          path: 'trash/groups/historical',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
